import styled from 'styled-components';

export const NftMediaIconWrapper = styled.div`
  position: absolute;
  z-index: 10;
  height: 50px;
  width: 50px;
  border: 1px solid var(--v3-white);
  border-radius: 50%;
  right: 24px;
  top: 24px;
  padding: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgb(0 0 0 / 35%);
  backdrop-filter: blur(5px);
`;
